// extracted by mini-css-extract-plugin
module.exports = {"root":"StarRating_root__R630d","stars":"StarRating_stars__sbJ0k","back":"StarRating_back__HudPi","front":"StarRating_front__Nl7t6","value":"StarRating_value__v_Mkr"};